import { render, staticRenderFns } from "./ReviewItemsWidget.vue?vue&type=template&id=5d1ba87e&scoped=true"
import script from "./ReviewItemsWidget.vue?vue&type=script&lang=js"
export * from "./ReviewItemsWidget.vue?vue&type=script&lang=js"
import style0 from "./ReviewItemsWidget.vue?vue&type=style&index=0&id=5d1ba87e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1ba87e",
  null
  
)

export default component.exports